// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 公共样式
import './assets/css/xunyou.css'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
//视频
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer);

import axios from 'axios';
Vue.prototype.setGlobleTitle = (title)=>{ document.title = title }
Vue.prototype.$axios = axios;
// Vue.prototype.$payUrl = 'http://39.98.76.44:28081/center/'
// Vue.prototype.$imUrl = 'http://39.98.76.44:8082' // 接口
// Vue.prototype.$wsUrl = 'ws://39.98.76.44:9326' // ws
// Vue.prototype.$demoUrl = 'http://39.98.76.44:28081/center' //支付测试接口

Vue.prototype.$payUrl = 'https://www.nays.com.cn/center/'
Vue.prototype.$imUrl = 'https://im.nays.com.cn' // 接口
Vue.prototype.$wsUrl = 'wss://im.nays.com.cn/websocket' // wss
Vue.prototype.$demoUrl = 'https://www.nays.com.cn/center' //支付测试接口
Vue.config.productionTip = false;
// axios.defaults.baseURL = '/api'

Vue.prototype.$baseUrl = 'https://www.nays.com.cn/center';
// Vue.prototype.$baseUrl = 'http://39.98.76.44:7000/center';



// Vue.prototype.$payUrl = 'http://192.168.0.148:28081/center/'
// Vue.prototype.$imUrl = 'http://192.168.0.148:8080' // 接口
// Vue.prototype.$wsUrl = 'ws://192.168.0.148:9326' // ws
// Vue.prototype.$demoUrl = 'http://192.168.0.148:28081/center' //支付测试接口
// Vue.config.productionTip = false;
// // axios.defaults.baseURL = '/api'

// Vue.prototype.$baseUrl = 'http://192.168.0.148:28081/center';




// 使用element UI
Vue.use(ElementUI);
//地图定位组件

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
    key: '在高德地图申请的key',
    // 插件集合 （插件按需引入）
    plugin: [
        "AMap.Autocomplete", //输入提示插件
        "AMap.PlaceSearch", //POI搜索插件
        "AMap.Scale", //右下角缩略图插件 比例尺
        "AMap.OverView", //地图鹰眼插件
        "AMap.ToolBar", //地图工具条
        "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        "AMap.PolyEditor", //编辑 折线多，边形
        "AMap.CircleEditor", //圆形编辑器插件
        "AMap.Geolocation" //定位控件，用来获取和展示用户主机所在的经纬度位置
    ],
    // 默认高德 sdk 版本为 1.4.15
	v: "1.4.15",
	  uiVersion: "1.1"
});
// 过滤器
import * as custom from './utils/util'

// 引入layui
// import layui from './assets/layui/layui'
// // import './assets/layui/css/modules/layer/default'
// Vue.prototype.$layui = layui

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 路由拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem("userdata"))) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
				// console.log("to",to);
				// console.log("from",from);
				// console.log("next",next);
				// console.log("to.path",to.path);
				// console.log("to.query.type",to.query.type);
				if (to.path == '/ConsultationComplaints/' && to.query.type == '咨询系统') {
					 next();
				}else{
					next({
                    path: '/login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
				}
            }
        }
        else {
            next();
        //     if (Boolean(localStorage.getItem("userdata"))) { // 判断是否登录
        //         if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
        //             next();
        //         } else {
        //             /**
        //              * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
        //              */
        //             next({
        //                 path: '/dashboard/main'
        //             })
        //         }
        //     } else {
        //         next();
        //     }
        }
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

// 禁止在控制台打印
// console.log = function(){}
//  alert = function(){}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})



// WEBPACK FOOTER //
// ./src/main.js